import { BASICLENGTHTYPE_ENUM, BASICTYPE_ENUM, LengthType,
// BASICLENGTHTYPE_ENUM,
 } from '../utils/enum';
import MeshManage from '../meshManage';
// import LengthX from '../lengthTypes/lengthX';
// import renderNoFrame from '../specialHandler/renderNoFrame';
import HightFrame from '../specialHandler/highFrame';
import { checkFrameIsHighFrame, checkPreFrameIsHighFrame } from '../utils/renderUtils';
import { SKIRTINGBOARDCONFIG, TOPFRAME_GROUND, FRAMEDEPTH } from '../utils/kitchenConfig';
import LengthP2X from '../lengthTypes/lengthP2X';
import renderNoFrame from '../specialHandler/renderNoFrame';
/**
 * 当I顶柜在Z轴上面的时候
 * @param renderIThis renderIType类型的renderIThis,由于引入该类型的时候会导致循环引用所以修改为any类型
 */
const renderIZTop = (renderIThis) => {
    var _a, _b, _c;
    console.log(renderIThis);
    const sealPlateData = renderIThis.getLengthSealPlate(BASICTYPE_ENUM.top);
    let datumPoint = null;
    let sealPlateMesh = null;
    const sealPlatePos = renderIThis.topLength2.getSealPlatePos(renderIThis.templateJson, BASICTYPE_ENUM.top, true);
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const sidePlateDepth = renderIThis.getSidePlateDepth(LengthType.Length2, BASICTYPE_ENUM.top);
    // 二字型特殊处理 顶部只有高柜情况
    // const checkLengthXPosTopNoFrames = LengthX.checkTopNoFrames(renderIThis.templateJson, BASICTYPE_ENUM.top);
    // if (checkLengthXPosTopNoFrames) {
    //   sealPlateMesh = renderNoFrame.renderSealPlate(
    //     sealPlateData.length1,
    //     BASICTYPE_ENUM.top,
    //     BASICLENGTHTYPE_ENUM.length1,
    //     renderIThis,
    //   );
    // }
    // 移动柜子到指定位置
    (_c = (_b = (_a = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.frames.forEach((element, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // 一期空高柜判断
        if (HightFrame.checkEmptyPlaceholderHighFrame(element)) {
            return;
        }
        // 高柜占位作用
        if (checkPreFrameIsHighFrame((_c = (_b = (_a = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.frames, index)) {
            const preEl = (_f = (_e = (_d = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length2) === null || _f === void 0 ? void 0 : _f.frames[index - 1];
            const preMeshManage = new MeshManage(renderIThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            const point = preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 });
            point.y = TOPFRAME_GROUND(renderIThis.templateJson) - meshManage.getModelSize().y;
            const { rotation } = meshManage.moveModelToPosition(point, { x: 0, y: 1, z: 1 });
            renderIThis.rotationMeshes[element.componentBasic.id] = rotation;
            // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
        }
        else if (index > 0) {
            const preEl = (_j = (_h = (_g = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.length2) === null || _j === void 0 ? void 0 : _j.frames[index - 1];
            const preMeshManage = new MeshManage(renderIThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            // 摆放补板后柜体处理
            if (sealPlateMesh && sealPlatePos && index === sealPlatePos) {
                datumPoint = sealPlateMesh.getDatumPoint({ x: 0, y: 1, z: 1 });
                // lengthZ边的一型柜moveModelToPosition会让柜体以补板中心去定位 此处特殊处理一下
                datumPoint = Object.assign(Object.assign({}, datumPoint), { x: -sealPlateMesh.getModelSize().x });
            }
            else {
                datumPoint = preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 });
            }
            const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: 0, y: 1, z: 1 });
            renderIThis.rotationMeshes[element.componentBasic.id] = rotation;
            // 高柜在顶柜上 移动 y
            if (checkFrameIsHighFrame(element)) {
                meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
            }
        }
        else {
            // 第一个位置为转角柜
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            meshManage.addRotation(0, -Math.PI / 2, 0);
            // const moveX = sealPlateMesh ? -sealPlateMesh.getModelSize().x : 0;
            const moveX = 0;
            meshManage.setModelPosition({
                x: -meshManage.getModelSize().z * 0.5 - 0.005 - sidePlateDepth + moveX,
                y: TOPFRAME_GROUND(renderIThis.templateJson) - meshManage.getModelSize().y,
                z: meshManage.getModelSize().x * 0.5,
            });
        }
        // 补板处理
        if (sealPlatePos && index === sealPlatePos - 1) {
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            // 渲染补板
            sealPlateMesh = renderIThis.topLength2.renderSealPlate(sealPlateData.length2, meshManage, BASICTYPE_ENUM.top, element, renderIThis, true);
        }
    });
};
/**
 * 当I顶柜在P2X轴上面的时候
 * @param renderIThis renderIType类型的renderIThis,由于引入该类型的时候会导致循环引用所以修改为any类型
 */
const renderIP2XTop = (renderIThis) => {
    var _a, _b, _c;
    console.log(renderIThis);
    const topToGround = TOPFRAME_GROUND(renderIThis.templateJson);
    const sealPlateData = renderIThis.getLengthSealPlate(BASICTYPE_ENUM.top);
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const sidePlateDepth = renderIThis.getSidePlateDepth('length1', 'top');
    let datumPoint = null;
    let sealPlateMesh = null;
    const sealPlateLengthP2XPos = renderIThis.topLength3.getSealPlatePos(renderIThis.templateJson, BASICTYPE_ENUM.top);
    // 顶部只有高柜情况
    datumPoint = null;
    sealPlateMesh = null;
    const checkLengthP2XPosTopNoFrames = LengthP2X.checkTopNoFrames(renderIThis.templateJson, BASICTYPE_ENUM.top);
    if (checkLengthP2XPosTopNoFrames) {
        sealPlateMesh = renderNoFrame.renderSealPlate(sealPlateData.length3, BASICTYPE_ENUM.top, BASICLENGTHTYPE_ENUM.length3, renderIThis);
    }
    (_c = (_b = (_a = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length3) === null || _c === void 0 ? void 0 : _c.frames.forEach((element, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
        if (index > 0) {
            const preEl = (_c = (_b = (_a = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length3) === null || _c === void 0 ? void 0 : _c.frames[index - 1];
            const preMeshManage = new MeshManage(renderIThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            // 摆放补板后柜体处理
            if (sealPlateMesh && sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 0, z: 1 });
            }
            else {
                datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 }, false);
            }
            const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 0, z: 1 });
            if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                meshManage.mesh.position.z += preMeshManage.getModelSize().z;
            }
            renderIThis.rotationMeshes[element.componentBasic.id] = rotation;
            if (checkFrameIsHighFrame(element)) {
                meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
            }
        }
        else {
            // l2的顶柜的位置使用l2的第一个底柜为基准点 如果是U型底柜有可能l3没有柜子 所以需要根据l2的最后一个柜子的位置来
            const bottomFirstEl = ((_f = (_e = (_d = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _d === void 0 ? void 0 : _d.bottom) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames[0])
                ? (_j = (_h = (_g = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _g === void 0 ? void 0 : _g.bottom) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames[0]
                : (_m = (_l = (_k = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _k === void 0 ? void 0 : _k.bottom) === null || _l === void 0 ? void 0 : _l.length2) === null || _m === void 0 ? void 0 : _m.frames[((_r = (_q = (_p = (_o = renderIThis === null || renderIThis === void 0 ? void 0 : renderIThis.templateJson) === null || _o === void 0 ? void 0 : _o.bottom) === null || _p === void 0 ? void 0 : _p.length2) === null || _q === void 0 ? void 0 : _q.frames) === null || _r === void 0 ? void 0 : _r.length) - 1];
            const preMeshManage = new MeshManage(renderIThis.scene.getMeshByName((_s = bottomFirstEl === null || bottomFirstEl === void 0 ? void 0 : bottomFirstEl.componentBasic) === null || _s === void 0 ? void 0 : _s.id));
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            const rotation = meshManage.addRotation(0, -Math.PI, 0);
            renderIThis.rotationMeshes[element.componentBasic.id] = rotation;
            const moveX = sealPlateMesh ? -sealPlateMesh.getModelSize().x : 0;
            const position = {
                x: -meshManage.getModelSize().x / 2 - sidePlateDepth + moveX,
                y: topToGround - meshManage.getModelSize().y,
                z: (((_u = (_t = preMeshManage === null || preMeshManage === void 0 ? void 0 : preMeshManage.mesh) === null || _t === void 0 ? void 0 : _t.position) === null || _u === void 0 ? void 0 : _u.z) || FRAMEDEPTH.BOTTOM * 4) // 底部没有底柜 x深度 + 过道 + p2x深度
                    + ((preMeshManage === null || preMeshManage === void 0 ? void 0 : preMeshManage.getModelSize().z) / 2 || 0)
                    - meshManage.getModelSize().z / 2,
            };
            meshManage.setModelPosition(position);
        }
        // 补板处理 需要在摆完柜子之后进行
        if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos - 1 && !checkLengthP2XPosTopNoFrames) {
            const meshManage = new MeshManage(renderIThis.scene.getMeshByName(element.componentBasic.id));
            // 渲染补板
            sealPlateMesh = renderIThis.topLength3.renderSealPlate(sealPlateData.length3, meshManage, BASICTYPE_ENUM.top, element, renderIThis);
        }
    });
};
export { renderIZTop, renderIP2XTop, };
